import { render, staticRenderFns } from "./d_GreenDeal.vue?vue&type=template&id=00ec1347"
import script from "./d_GreenDeal.vue?vue&type=script&lang=js"
export * from "./d_GreenDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports